import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    fetchGroups(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('groups', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchContractsOptions(ctx, params) {
      return new Promise((resolve, reject) => {
        axios.get('userGetLinked', {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchGroup(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`groups/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createGroup(ctx, groupData) {
      return new Promise((resolve, reject) => {
        axios.post('groups', groupData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editGroup(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.put(`groups/${form.id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteGroup(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`groups/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
